import Vue from 'vue';

function intlFormat(value: number, options?: Intl.NumberFormatOptions) {
	let locale = Vue.prototype.$store.getLocale();

	// numbers in cs-CZ locale should be formatted according to de-DE locale
	if (locale === 'cs-CZ') {
		locale = 'de-DE';
	}

	return Intl.NumberFormat(locale, options).format(value);
}

export function formatNumber(value: number) {
	return intlFormat(value);
}

export function formatRoundedNumber(value: number, maximumFractionDigits: number = 0) {
	return intlFormat(value, {
		maximumFractionDigits
	});
}
